/** Keep the timeout signal alive while the response body is being read, too. */
export function fetchWithTimeout(request: Request, timeoutMs = 30_000): Promise<Response> {
  const signal = AbortSignal.any([request.signal, AbortSignal.timeout(timeoutMs)])
  return fetch(new Request(request, { signal }))
}
